import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Stores from "./Components/Store/StoreMain";
import Home from "./Components/Home/Home";
import StoreDetails from "./Components/StoreDetails/StoreDetails.jsx";
import ProductMain from "./Components/Product/ProductMain.jsx";
import CatalogDetails from "./Components/CatalogDetails/CatalogDetails.jsx";

function App() {
    const [selectedArea, setSelectedArea] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(() => {
      return !!localStorage.getItem("accessToken");
    });
      const [showAuthModal, setShowAuthModal] = useState(false);
    
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home 
        selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        setShowAuthModal={setShowAuthModal}
        showAuthModal={showAuthModal}

        />} />
        <Route path="/Store" element={<Stores
        selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        setShowAuthModal={setShowAuthModal}
        showAuthModal={showAuthModal}
        
        />} />
        <Route path="/storedetails/:storeName/catalog/:storeId" element={<StoreDetails
        selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        setShowAuthModal={setShowAuthModal}
        showAuthModal={showAuthModal}
        />} />
      <Route path="/products/:hyveProductId" element={<ProductMain
      selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        setShowAuthModal={setShowAuthModal}
        showAuthModal={showAuthModal}
      />} />

            <Route path="/:storeName/catalog/:catalogId" element={<CatalogDetails
      selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        setShowAuthModal={setShowAuthModal}
        showAuthModal={showAuthModal}
      />} />

      </Routes>

    </Router>
  );
}

export default App;
